export var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["PRIMARY"] = 0] = "PRIMARY";
    ButtonType[ButtonType["SECONDARY"] = 1] = "SECONDARY";
    ButtonType[ButtonType["TERTIARY"] = 2] = "TERTIARY";
    ButtonType[ButtonType["DANGER"] = 3] = "DANGER";
    ButtonType[ButtonType["WARNING"] = 4] = "WARNING";
    ButtonType[ButtonType["INFO"] = 5] = "INFO";
    ButtonType[ButtonType["NOT_FILLED"] = 6] = "NOT_FILLED";
})(ButtonType || (ButtonType = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize[ButtonSize["SMALL"] = 0] = "SMALL";
    ButtonSize[ButtonSize["MEDIUM"] = 1] = "MEDIUM";
    ButtonSize[ButtonSize["LARGE"] = 2] = "LARGE";
})(ButtonSize || (ButtonSize = {}));
export var HtmlButtonType;
(function (HtmlButtonType) {
    HtmlButtonType["BUTTON"] = "button";
    HtmlButtonType["RESET"] = "reset";
    HtmlButtonType["SUBMIT"] = "submit";
})(HtmlButtonType || (HtmlButtonType = {}));
export var ButtonIconLocation;
(function (ButtonIconLocation) {
    ButtonIconLocation[ButtonIconLocation["LEFT"] = 0] = "LEFT";
    ButtonIconLocation[ButtonIconLocation["RIGHT"] = 1] = "RIGHT";
})(ButtonIconLocation || (ButtonIconLocation = {}));
